import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-data-grid-pro";
const mui_x_license_key =
  "660384fa1672cbd9951a0baefacb1227Tz03MjIxNCxFPTE3MjI4NzEwNTkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";

LicenseInfo.setLicenseKey(mui_x_license_key);

const THEME = createTheme({
  typography: {
    fontFamily: `Roboto`,
    fontSize: 12,
    body1: {
      color: "#04334E",
    },
  },
  palette: {
    text: {
      primary: "#04334E",
    },
    primary: {
      main: "#04334E",
    },
    secondary: {
      main: "#FCF3ED",
    },
    success: {
      main: "#0DBC29",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={THEME}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
